export default function SystemSettings() {
  return (
    <>
      <h1>System Settings</h1>

      <h2>Domain/DNS Access</h2>
      <ul>
        <li><a href="https://sso.godaddy.com/?realm=idp&path=%2Fproducts&app=account" target="_blank" rel="noopener noreferrer">GoDaddy</a></li>
        <li><a href="https://www.namecheap.com/myaccount/login/" target="_blank" rel="noopener noreferrer">Namecheap</a></li>
        <li><a href="https://dash.cloudflare.com/login" target="_blank" rel="noopener noreferrer">Cloudflare</a></li>
      </ul>

      <h2>Hosting Accounts</h2>
      <ul>
        <li><a href="https://dash.cloudflare.com/login" target="_blank" rel="noopener noreferrer">Cloudflare</a></li>
        <li><a href="https://www.hostinger.in/cpanel-login" target="_blank" rel="noopener noreferrer">Hostinger</a></li>
        <li><a href="https://partners.shopify.com/organizations" target="_blank" rel="noopener noreferrer">Shopify Partner</a></li>
      </ul>

      <h2>Database Access</h2>
      <ul>
        <li>
          <a href="https://console.firebase.google.com/" target="_blank" rel="noopener noreferrer">Firebase Firestore</a>
          <ul>
            <li>
              To backup your Firestore data, navigate to the Firestore section
              in the Firebase console, select the desired database, click
              "Disaster Recovery", then "View in Google Cloud", and follow the
              instructions.
            </li>
          </ul>
        </li>
      </ul>

      <h2>Payment Integrations</h2>
      <ul>
        <li><a href="https://dashboard.stripe.com/login" target="_blank" rel="noopener noreferrer">Stripe</a></li>
        <li><a href="https://dashboard.razorpay.com/#/access/signin" target="_blank" rel="noopener noreferrer">Razorpay</a></li>
      </ul>

      <h2>Third Party APIs</h2>
      <ul>
        <li><a href="https://www.twilio.com/login" target="_blank" rel="noopener noreferrer">Twilio</a></li>
        <li><a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer">Google Console</a></li>
        <li><a href="https://developer.apple.com/account/" target="_blank" rel="noopener noreferrer">Apple Developer Console</a></li>
        <li><a href="https://accounts.random.org/" target="_blank" rel="noopener noreferrer">Random.org</a></li>
        <li><a href="https://platform.openai.com/login" target="_blank" rel="noopener noreferrer">OpenAI</a></li>
      </ul>

      <h1>Repository Links</h1>
      <ul>
        <li><a href="https://github.com/WeCarryBags/admin-dashboard" target="_blank" rel="noopener noreferrer">Admin Dashboard</a></li>
        <li><a href="https://github.com/WeCarryBags/doc" target="_blank" rel="noopener noreferrer">Master Document</a></li>
        <li><a href="https://github.com/WeCarryBags/tipping-page" target="_blank" rel="noopener noreferrer">Tipping Page</a></li>
        <li><a href="https://github.com/WeCarryBags/draw" target="_blank" rel="noopener noreferrer">Draw</a></li>
        <li><a href="https://github.com/WeCarryBags/web-app" target="_blank" rel="noopener noreferrer">Web App</a></li>
        <li><a href="https://github.com/WeCarryBags/backend" target="_blank" rel="noopener noreferrer">Backend</a></li>
        <li><a href="https://github.com/WeCarryBags/website" target="_blank" rel="noopener noreferrer">Website</a></li>
        <li><a href="https://github.com/WeCarryBags/store-dashboard" target="_blank" rel="noopener noreferrer">Store Dashboard</a></li>
        <li><a href="https://github.com/WeCarryBags/pss-dashboard" target="_blank" rel="noopener noreferrer">PSS Dashboard</a></li>
        <li><a href="https://github.com/WeCarryBags/shopify-app" target="_blank" rel="noopener noreferrer">Shopify App</a></li>
      </ul>
    </>
  )
}
